export default __webpack_public_path__ + "static/man-1ebb053e0058762aeb6c24592db5d308.png";